module.exports = __webpack_public_path__ + "img/Bodice-Front-B7-Gd-Da-Eb.1b93c7ff.png";